import React, { useEffect, useState } from "react";
// import { IArticle } from "../order/orderDetail";
import AmountInput from "../AmountInput/AmountInput";
import { useActiveSalesWrapStore, useSelectedArticleStore } from "../../store/store";
import classNames from "classnames";
import { AddArticleToSalesWrapRequest, Article, SalesOrderApi, SalesWrap } from "../../api/order/generated/src";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
import { Button } from "@mui/material";
import BatchInfoPopup from "../BatchInfoPopup/BatchInfoPopup";
import SerialInfoPopup from "../SerialInfoPopup/SerialInfoPopup";
import { BsCalendar, BsHash, BsPlus } from "react-icons/bs";
import { getOrderApiConfig } from "../../api-configs/OrderApiConfig";
import AmountInputV2 from "../AmountInput/AmountInputV2";

interface ISalesArticleDetailProps {
    // articleId:string;

    article:Article;
}


interface IArticleAmount {
    articleId: string;
    batch?:string;
    serial?:string;
    value: number;
}

const SalesArticleDetail = (props:ISalesArticleDetailProps) => {
    const { article } = props;

    const { t } = useTranslation();

    const selectedArticle = useSelectedArticleStore(state => state.article);

    const setSelectedArticle = useSelectedArticleStore(state => state.updateSelected);

    const salesWrap = useActiveSalesWrapStore(state => state.salesWrap);
    const setSalesWrap = useActiveSalesWrapStore(state => state.updateActive);


    const [tmpArticle, setTmpArticle] = useState<Article>(article);


    const [batchPopupOpen, setBatchPopupOpen] = useState(false);
    const [serialPopupOpen, setSerialPopupOpen] = useState(false);



    useEffect(() => {
        setTmpArticle(article);
    }, [article]);


    const orderId = salesWrap.id;
    
    const incrementArticleAmount = async (data:IArticleAmount) => {

        if(orderId){
            const salesOrderApi:SalesOrderApi = new SalesOrderApi(getOrderApiConfig());
    
            let newSalesWrap:SalesWrap|null = null;
                
            try {
                // const newSalesWrap = await salesOrderApi.incrementArticleAmount({id:orderId, });
                const tmpSalesWrap = await salesOrderApi.incrementArticleAmount({id:orderId, articleId:data.articleId, amount:data.value.toString(), batch: data.batch});
    
                newSalesWrap = tmpSalesWrap;
                
                
            } catch (error) {
                
            }    

            // fake it til u make it 
            // if(!newSalesWrap){
            //     newSalesWrap = {...salesWrap};

            //     newSalesWrap.quantityBooked = (newSalesWrap.quantityBooked ?? 0) + data.value;

            //     const tmpArticle = newSalesWrap?.articles?.find((article) => {
            //         return article.id === data.articleId;
            //     });

            //     if(tmpArticle){
            //         tmpArticle.quantityBooked = (tmpArticle.quantityBooked ?? 0) + data.value;
                

            //         if(data.batch && data.batch !== ""){
            //             const batches = [...tmpArticle?.batchItems ?? []];
    
            //             const found = batches.find((b) => {
            //                 return b.batch === data.batch;
            //             });
    
            //             if(found){
            //                 const newBooked = (tmpArticle.quantityBooked ?? 0) + data.value;
            //                 found.quantityBooked = (found.quantityBooked ?? 0) + data.value;
    
            //                 // setTmpArticle((old) => {
            //                 //     return {
            //                 //         ...old,
            //                 //         batchItems: [...batches],
            //                 //         booked: newBooked
            //                 //     }
            //                 // })
            //             }
            //         }
            //         else if(data.serial && data.serial !== ""){
                       
            //         }
            //         else{
            //             const newBooked = (tmpArticle.quantityBooked ?? 0) + data.value;
    
            //             // setTmpArticle((old) => {
            //             //     return {
            //             //         ...old,
            //             //         booked: newBooked
            //             //     }
            //             // })
            //         }
            //     }

            // }


            if(newSalesWrap){
                setSalesWrap(newSalesWrap);
            }

        }
        
        
    }

    const setArticleAmount = async (data:IArticleAmount) => {

        if(orderId){
            const salesOrderApi:SalesOrderApi = new SalesOrderApi(getOrderApiConfig());
    
            let newSalesWrap:SalesWrap|null = null;
                
            try {
                // const newSalesWrap = await salesOrderApi.incrementArticleAmount({id:orderId, });
                const tmpSalesWrap = await salesOrderApi.setArticleAmount({id:orderId, articleId:data.articleId, amount:data.value.toString(), batch: data.batch});
    
                newSalesWrap = tmpSalesWrap;
                
                
            } catch (error) {
                
            }    

            // fake it til u make it 
            // if(!newSalesWrap){
            //     newSalesWrap = {...salesWrap};

            //     // newSalesWrap.quantityBooked = (newSalesWrap.quantityBooked ?? 0) + data.value;

            //     const tmpArticle = newSalesWrap?.articles?.find((article) => {
            //         return article.id === data.articleId;
            //     });

            //     if(tmpArticle){
            //         // tmpArticle.quantityBooked = (tmpArticle.quantityBooked ?? 0) + data.value;
                

            //         if(data.batch && data.batch !== ""){
            //             const batches = [...tmpArticle?.batchItems ?? []];

            //             const found = batches.find((b) => {
            //                 return b.batch === data.batch;
            //             });

            //             if(found){
            //                 // newSalesWrap.quantityBooked = (newSalesWrap.quantityBooked ?? 0) - (tmpArticle.quantityBooked ?? 0) + data.value;
                            
            //                 tmpArticle.quantityBooked = (tmpArticle.quantityBooked ?? 0) - (found.quantityBooked ?? 0) + data.value;

            //                 found.quantityBooked = data.value;


            //                 // setTmpArticle((old) => {
            //                 //     return {
            //                 //         ...old,
            //                 //         batchItems: [...batches],
            //                 //         // booked: newBooked
            //                 //     }
            //                 // })
            //             }
            //         }
            //         else if(data.serial && data.serial !== ""){
                        
            //         }
            //         else{

            //             // newSalesWrap.quantityBooked = (newSalesWrap.quantityBooked ?? 0) - (tmpArticle.quantityBooked ?? 0) + data.value;

            //             tmpArticle.quantityBooked = data.value;
                        
            //             // const newBooked = data.value;



            //             // setTmpArticle((old) => {
            //             //     return {
            //             //         ...old,
            //             //         booked: newBooked
            //             //     }
            //             // })
            //         }
            //     }

            // }


            if(newSalesWrap){
                setSalesWrap(newSalesWrap);
            }

        }



    }


    const addNewSerialOrBatch = async (data:{articleId:string, serial?:string, batch?:string}) => {

        if(orderId){
            const salesOrderApi:SalesOrderApi = new SalesOrderApi(getOrderApiConfig());
    
            let newSalesWrap:SalesWrap|null = null;
                
            try {
                // const newSalesWrap = await salesOrderApi.incrementArticleAmount({id:orderId, });

                                
                // Body nach dem Schema des OpenAPI-Generators
                const body: AddArticleToSalesWrapRequest = {
                    articleId: data.articleId,
                    serialNumber: data.serial,
                    batch: data.batch,
                };

                const tmpSalesWrap = await salesOrderApi.addArticleToSalesWrap({id:orderId, addArticleToSalesWrapRequest:body});
    
                newSalesWrap = tmpSalesWrap;
                
                
            } catch (error) {
                
            }    

            // fake it til u make it 
            // if(!newSalesWrap){
            //     newSalesWrap = {...salesWrap};


            // }


            if(newSalesWrap){
                setSalesWrap(newSalesWrap);
            }

        }



    }



    const renderBatch = () => {

        if(tmpArticle.type === "BATCH"){
            const articleSelected = tmpArticle.id === selectedArticle.id;

            let lines:React.ReactNode = [];

            if(tmpArticle.batchItems != null && tmpArticle.batchItems.length > 0){

                lines = tmpArticle.batchItems.map((lineItem) => {
    
                    const batchSelected = tmpArticle.id === selectedArticle.id && lineItem.batch === selectedArticle.subId;
    
                    return (
                        <div 
                            key={lineItem.batch}
                            className={classNames(
                                "bg-white p-3 rounded border", 
                                // {"rounded-md selected-subarticle border border-[green]": batchSelected},
                                // {"rounded-md selected-subarticle border border-[gray]": !batchSelected},
    
                                {"ring-2 ring-blue-500 border-blue-300 bg-blue-50": batchSelected},
                                {"hover:border-gray-300 hover:shadow-sm": !batchSelected}
                            )}
    
                            onClick={(event) => {
                                if(tmpArticle.id && lineItem.batch){
                                    setSelectedArticle(tmpArticle.id, lineItem.batch);
                                }
    
                                event.preventDefault();
                                event.stopPropagation();
                            }}
                        >
                            <div className="flex items-center justify-between mb-2">
                              <div className="flex items-center space-x-2">
                                <span className="font-mono text-sm font-medium">{lineItem.batch}</span>
                               
                              </div>
    
                              <div className="flex items-center space-x-2">
                                {/* <button
                                  onClick={() => updateBatchQuantity(item.id, batch.batchNumber, -1)}
                                  className="w-6 h-6 rounded-full bg-gray-100 flex items-center justify-center hover:bg-gray-200 transition-colors"
                                >
                                  <Minus className="w-3 h-3" />
                                </button> */}
                                <span className="w-8 text-center text-sm font-medium">{lineItem.quantityBooked}</span>
                                {/* <button
                                  onClick={() => updateBatchQuantity(item.id, batch.batchNumber, 1)}
                                  className="w-6 h-6 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center hover:bg-blue-200 transition-colors"
                                >
                                  <Plus className="w-3 h-3" />
                                </button> */}
                              </div>
    
                            </div>
                            <div className="text-xs text-gray-600 grid grid-cols-2 gap-4">
                              <div>
                                <span className="font-medium">{t("common:productiondate")}:</span> {lineItem.productionDate != null && format(lineItem.productionDate, "dd.MM.yyyy")}
                              </div>
                              <div 
                                // className={isExpiringSoon ? 'text-red-600 font-medium' : ''}
                              >
                                <span className="font-medium">{t("common:bestBefore")}:</span> {lineItem.bestBefore != null && format(lineItem.bestBefore, "dd.MM.yyyy")}
                              </div>
                            </div>
    
    
    
    
                            {batchSelected &&
                                // <AmountInput onChange={(newVal: number, increment: boolean) => {
    
                                //     if(increment){
                                //         incrementArticleAmount({articleId:selectedArticle.id, batch: selectedArticle.subId, value: newVal} );
                                //     }
                                //     else{
                                //         setArticleAmount({articleId:selectedArticle.id, batch: selectedArticle.subId, value: newVal} );
                                //     }
                    
                                // }}/>
    
                                <AmountInputV2 onChange={(newVal: number, increment: boolean) => {
    
                                    if(increment){
                                        incrementArticleAmount({articleId:selectedArticle.id, batch: selectedArticle.subId, value: newVal} );
                                    }
                                    else{
                                        setArticleAmount({articleId:selectedArticle.id, batch: selectedArticle.subId, value: newVal} );
                                    }
                    
                                }}/>
                            }
    
                        </div>                    
                    );
                })
            }


            return (
                
                // <div className="flex flex-col gap-2">

                <div className="mt-4 p-3 bg-gray-50 rounded-lg border border-gray-200">
                    <h4 className="font-medium text-gray-900 mb-3 flex items-center space-x-2">
                        <BsCalendar className="w-4 h-4" />
                        <span>{t("common:batch")}</span>
                    </h4>

                
                    {articleSelected &&
                        <>
                            <Button
                                variant="contained" 
                                
                                onClick={() => setBatchPopupOpen(true)}
                                // className="px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                                // className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors !mb-2"
                                className="w-full px-4 py-2 !bg-blue-100 !text-blue-600 rounded-lg hover:bg-blue-700 transition-colors !mb-2"
                            >
                                <BsPlus className="w-4 h-4" />
                                {t("common:addBatch")}
                            </Button>

                            

                


                            <BatchInfoPopup
                                open={batchPopupOpen}
                                onClose={() => setBatchPopupOpen(false)}
                                
                                // selectedArticle={selectedArticle}
                                selectedArticle={{
                                    id: tmpArticle.id ?? "",
                                    // name: tmpArticle.title ?? "",
                                    // description: tmpArticle.description
                                    
                                    name: tmpArticle.externalId ?? "",
                                    description: tmpArticle.title

                                }}
                                
                                onSave={(batchInfoData) => {

                                    if(tmpArticle.id){
                                        addNewSerialOrBatch({
                                            articleId: tmpArticle.id,
                                            batch: batchInfoData.batchNumber
                                        })

                                    }

                                    setBatchPopupOpen(false);
                                }} 
                            />
                        </>


                    }

                    <div className="space-y-2">
                        {lines}
                    </div>

                </div>
            );
        }

        return null;
    }

    const renderSerial = () => {

        if(tmpArticle.type === "SERIAL"){
            const articleSelected = tmpArticle.id === selectedArticle.id;

            let lines:React.ReactNode = [];

            
            if(tmpArticle.serialItems != null && tmpArticle.serialItems.length > 0){


                lines = tmpArticle.serialItems.map((lineItem) => {
                                                    
                    const serialSelected = tmpArticle.id === selectedArticle.id && lineItem.serial === selectedArticle.subId;

                    return (

                        <div 
                            key={lineItem.serial}
                            className={classNames(
                                "flex items-center justify-between bg-white p-2 rounded border", 
                                // {"rounded-md selected-subarticle border border-[green]": serialSelected},
                                // {"rounded-md selected-subarticle border border-[gray]": !serialSelected}

                                // {"ring-2 ring-blue-500 border-blue-300 bg-blue-50": serialSelected},
                                // {"hover:border-gray-300 hover:shadow-sm": !serialSelected}
                            )}
                        >
                            <span className="font-mono text-sm">{lineItem.serial}</span>
                            {/* <button
                                onClick={() => removeSerialNumber(item.id, serialNumber)}
                                className="text-red-600 hover:text-red-800 p-1"
                            >
                                <Minus className="w-4 h-4" />
                            </button> */}
                        </div>
                    );
                })
            }

            return (
                <div className="mt-4 p-3 bg-gray-50 rounded-lg border border-gray-200">
                    <h4 className="font-medium text-gray-900 mb-3 flex items-center space-x-2">
                        <BsHash className="w-4 h-4" />
                        <span>{t("common:serial")}</span>
                    </h4>


                    {articleSelected &&
                        <>
                            <Button
                                variant="contained" 
                                onClick={() => setSerialPopupOpen(true)}
                                // className="w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors !mb-2"
                                className="w-full px-4 py-2 !bg-blue-100 !text-blue-600 rounded-lg hover:bg-blue-700 transition-colors !mb-2"
                            >
                                {t("common:addSerial")}
                            </Button>


                            <SerialInfoPopup
                                open={serialPopupOpen}
                                onClose={() => setSerialPopupOpen(false)}
                                
                                // selectedArticle={selectedArticle}
                                selectedArticle={{
                                    id: tmpArticle.id ?? "",
                                    name: tmpArticle.title ?? "",
                                    description: tmpArticle.description

                                }}
                                onSave={(serialInfoData) => {

                                    if(tmpArticle.id){
                                        addNewSerialOrBatch({
                                            articleId: tmpArticle.id,
                                            serial: serialInfoData.serialNumber
                                        })

                                    }

                                    setSerialPopupOpen(false);
                                }}
                            />
                        </>


                    }
                    
                    <div className="space-y-2">
                        {lines}
                    </div>

                </div>
            );
        }

        return null;
    }

    const renderDefault = () => {

        // if(!(tmpArticle.serialItems != null && tmpArticle.serialItems.length > 0) && !(tmpArticle.batchItems != null && tmpArticle.batchItems.length > 0)){
        if(!(tmpArticle.type === "SERIAL") && !(tmpArticle.type === "BATCH")){
        
            const articleSelected = tmpArticle.id === selectedArticle.id && selectedArticle.subId === "";

            if(articleSelected){
                return (
                    // <AmountInput onChange={(newVal: number, increment: boolean) => {

                    //     if(increment){
                    //         incrementArticleAmount({articleId:selectedArticle.id, value: newVal} );
                    //     }
                    //     else{
                    //         setArticleAmount({articleId:selectedArticle.id, value: newVal} );
                    //     }
        
                    // }}/>
                    <AmountInputV2 onChange={(newVal: number, increment: boolean) => {

                        if(increment){
                            incrementArticleAmount({articleId:selectedArticle.id, value: newVal} );
                        }
                        else{
                            setArticleAmount({articleId:selectedArticle.id, value: newVal} );
                        }
        
                    }}/>
                )
            }
        }

        return null;
    }

    return (
        <div className="w-full  h-full">

            <div className="w-full">
                {/* <div>{article.title}</div> */}
                <div className="flex flex-col gap-4">

                    {renderBatch()}
                    {renderSerial()}
                    {renderDefault()}
            
                    
                </div>
            </div>
                    
        </div>
    )
};

export default SalesArticleDetail;
